import { CommandHelp } from "./CommandHelp.client";
import { Command } from "@/lib/acli/backend"
import { CodeHighlight } from "@/components/wysiwyg/CodeHighlight.client";
import { CommandSearchResults } from "./CommandSearchResults.client";

export async function CommandApp({resource, basePath}: {
  resource: Command|null
  basePath: string
}) {

  return (
    <>
      { resource ? (<CommandHelp {...resource} />) : (
        <div className="meta-content">
          <p>Use the command search above or the index listing below to find documentation on Acquia CLI commands.</p>
          <h2 className="text-lg font-display my-1 mt-4 text-gray-800 font-semibold">Usage</h2>
          <p>You can use the <code>list</code> command to list all commands available in your version of Acquia CLI.</p>
          <pre>
            <CodeHighlight language="bash">
              acli list
            </CodeHighlight>
          </pre>

          <p>To view the command documentation in the CLI, use the <code>help</code> command or the <code>--help</code> option of a command:</p>
          <pre><CodeHighlight language="bash">
            {`# Example: Accessing documentation on the \`pull:database\` command.
acli help pull:database

# Or use the --help option on the command:
acli pull:database --help`}
          </CodeHighlight></pre>
          <CommandSearchResults query={''} slugBase={basePath} />
        </div>
      )}
    </>
  )
}